import Vue from 'vue'
import Router from 'vue-router'

let isPC = function() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('./views/index'),
      meta: {title: '云柑5G云店'}
    },
    {
      path: '/a/:code',
      name: 'openApp',
      props: true,
      component: () => import('./views/openApp'),
      meta: { title: '云柑5G云店', requireAuth: false, cn: '短连接，跳转至 wx.anttalk.vip/a'}
    },
    {
      path: '/miniApp',
      name: 'miniApp',
      props: true,
      component: () => import('./views/miniApp'),
      meta: { title: '云柑5G云店', requireAuth: false, cn: '小程序链接，跳转至 /a/:code'}
    },
    {
      path: '/404',
      component: () => import('./views/404'),
      meta: {title: '云柑5G云店-404'}
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('./views/help'),
      meta: {title: '云柑5G云店'}
    },
    
    // 云柑5G云店--版本说明
    {
      path: '/version',
      name: 'version',
      component: () => import('./views/version/index.vue'),
      meta: {title: '版本更新说明'}
    },
    {
      path: '/version/ios',
      name: 'versionIOS',
      component: () => import('./views/version/ios.vue'),
      meta: {title: '版本更新说明'}
    },
    {
      path: '/version/android',
      name: 'versionANDROID',
      component: () => import('./views/version/android.vue'),
      meta: {title: '版本更新说明'}
    },
    {
      path: '/version/android/detail-:ver',
      name: 'versionANDROIDDetail',
      props: true,
      component: () => import('./views/version/detail-android.vue'),
      meta: {title: '主要更新内容'}
    },
    {
      path: '/version/ios/detail-:ver',
      name: 'versionIOSDetail',
      props: true,
      component: () => import('./views/version/detail-ios.vue'),
      meta: {title: '主要更新内容'}
    },
    
  
    // 云柑5G云店协议
    {
      path: '/5gShop/agreement',
      name: '5gShopAgreement',
      component: () => import('./views/agreement/index.vue'),
      meta: {title: '云柑5G云店-协议'}
    },
    {
      path: '/5gShop/agreement/user',
      name: '5gShopAgreementUser',
      component: () => import('./views/agreement/user.vue'),
      meta: {title: '云柑5G云店用户协议'}
    },
    {
      path: '/5gShop/agreement/privacy',
      name: '5gShopAgreementPrivacy',
      component: () => import('./views/agreement/privacy.vue'),
      meta: {title: '云柑5G云店隐私政策'}
    },
    {
      path: '/5gShop/agreement/member',
      name: '5gShopAgreementMember',
      component: () => import('./views/agreement/member.vue'),
      meta: {title: '云柑5G云店会员服务协议'}
    },
    {
      path: '/5gShop/agreement/shop',
      name: '5gShopAgreementShop',
      component: () => import('./views/agreement/shop.vue'),
      meta: {title: '云柑5G云店服务协议'}
    },
    {
      path: '/5gShop/agreement/cancellationAccount',
      name: '5gShopAgreementCancellationAccount',
      component: () => import('./views/agreement/cancellationAccount.vue'),
      meta: {title: '云柑5G云店账号注销须知'}
    },
    
    
    
  
    {path: '*', redirect: '/404', hidden: true, meta: { permission: false }}
  ]
})
